import { addToDebugData, ProductUtils } from '@wix/package-picker-shared';
import { PremiumPurchasePlatformModule } from '@wix/premium-purchase-platform/@sdk';
import { StudioOfferingApiClientContext } from '../studio-offering.context';
export const fetchProductQueryFn = async props => {
  var _productCardListData$;
  const {
    httpClient,
    request: {
      productId
    }
  } = props;
  const {
    getProductCardList
  } = PremiumPurchasePlatformModule.SDK.ApiClient.queries({
    httpClient
  });
  const p3Context = StudioOfferingApiClientContext.get('p3Context');
  if (!p3Context) {
    throw new Error('P3 context is required to fetch product');
  }
  const productCardListData = await getProductCardList(p3Context);
  if (!productCardListData || !productCardListData.products) {
    throw new Error('Product card list data is empty');
  }
  const {
    products,
    features,
    recommendedProductFamily
  } = productCardListData;
  addToDebugData({
    products,
    recommendedProductFamily
  });
  const product = products.find(p => p.productId === productId);
  const isRecommended = (recommendedProductFamily == null ? void 0 : recommendedProductFamily.productFamilyId) === (product == null ? void 0 : product.productFamilyId);
  const isEnterprise = ProductUtils.isEnterpriseProduct(product);
  const pricingDetails = product == null ? void 0 : product.pricingDetails;
  return {
    name: (product == null ? void 0 : product.name) ?? '',
    description: (product == null ? void 0 : product.description) ?? '',
    features: features.getByProductId(productId),
    isRecommended,
    isEnterprise,
    recommendedDisplayText: productCardListData == null || (_productCardListData$ = productCardListData.recommendedProductFamily) == null || (_productCardListData$ = _productCardListData$.displayInfo) == null ? void 0 : _productCardListData$.displayText,
    pricingDetails
  };
};
//# sourceMappingURL=fetch-product.query.js.map